import "../styles/Arrow.css";
import "../styles/Button.css";


function Arrow(){
    return (
        <svg className="button__text d-arrow" enableBackground="new 0 0 256 256" height="60px" width="60px" id="Layer_1" viewBox="0 0 256 256" xmlSpace="preserve" >
            <path  d="M76.8,217.6c0-1.637,0.625-3.274,1.875-4.524L163.75,128L78.675,42.925c-2.5-2.5-2.5-6.55,0-9.05s6.55-2.5,9.05,0  l89.601,89.6c2.5,2.5,2.5,6.551,0,9.051l-89.601,89.6c-2.5,2.5-6.55,2.5-9.05,0C77.425,220.875,76.8,219.237,76.8,217.6z"/>
        </svg>
    );
}

export default Arrow;